import React from 'react';

function Accommodation() {
  const accommodations = [
    {
      name: 'Crondon Park Farm',
      address: 'Crondon Park Lane, Stock, Essex CM4 9QT, UK',
      phone: '+44 1277 840042',
      image: '/accommodation-images/Crondon-Park-Farm.jpg',
      link: 'https://www.crondonparkfarm.com/',
      distanceToVenue: '0.03 miles'
    },
    {
      name: 'Greenwoods Hotel & Spa',
      address: 'Stock Road, Stock, Essex CM4 9BE, UK',
      phone: '+44 1277 829990',
      image: '/accommodation-images/greenwoods-hotel.jpg',
      link: 'https://www.greenwoodshotel.com/',
      distanceToVenue: '0.5 miles'
    },
    {
      name: 'The Harvard Inn',
      address: 'High Street, Stock, Essex CM4 9BJ, UK',
      phone: '+44 1277 840008',
      image: '/accommodation-images/harvard-inn.jpg',
      link: 'https://www.theharvardinn.co.uk/',
      distanceToVenue: '0.8 miles'
    },
    {
      name: 'Little Pear Tree (sleeps up to 4)',
      address: 'Smallgains Lane, Stock, Essex CM4 9PR, UK',
      phone: '+447768 596460',
      image: '/accommodation-images/Little-Pear-Tree.jpg',
      link: 'mailto:mmelleney1957@outlook.com',
      distanceToVenue: '2 miles'
    },
    {
      name: 'The White Hart Inn',
      address: 'White Hart Inn, Swan Ln, Margaretting Tye, Ingatestone, CM4 9JX',
      phone: '+441277282382',
      image: '/accommodation-images/white-hart-inn.jpg',
      link: 'https://www.whitehartinnessex.co.uk/',
      distanceToVenue: '3 miles'
    },
    {
      name: 'Ivy Hill Hotel',
      address: 'Writtle Road, Margaretting, Ingatestone, Essex CM4 0EH, UK',
      phone: '+44 1277 353040',
      image: '/accommodation-images/ivy-hill-hotel.jpg',
      link: 'https://www.ivyhillhotel.co.uk/',
      distanceToVenue: '3 miles'
    },
    {
      name: 'Pontlands Park Hotel',
      address: 'West Hanningfield Rd, Great Baddow, Chelmsford CM2 8HR, UK',
      phone: '+44 1245 476444',
      image: '/accommodation-images/pontlands-park.jpg',
      link: 'https://www.pontlandspark.co.uk/',
      distanceToVenue: '5 miles'
    },
    {
      name: 'Premier Inn Chelmsford (Boreham)',
      address: 'Main Road, Chelmsford, Essex CM3 3HJ, UK',
      phone: '+44 333 777 3997',
      image: '/accommodation-images/premier-inn-boreham.jpg',
      link: 'https://www.premierinn.com/gb/en/hotels/england/essex/chelmsford/chelmsford-boreham.html',
      distanceToVenue: '6 miles'
    },
    {
      name: 'Best Western Atlantic Hotel',
      address: 'New Street, Chelmsford, Essex CM1 1PP, UK',
      phone: '+44 1245 268168',
      image: '/accommodation-images/atlantic-hotel.jpg',
      link: 'https://www.atlantichotelchelmsford.co.uk/',
      distanceToVenue: '7 miles'
    },
    {
      name: 'The County Hotel',
      address: '29 Rainsford Rd, Chelmsford CM1 2PZ, UK',
      phone: '+44 1245 455700',
      image: '/accommodation-images/county-hotel.jpg',
      link: 'https://thecountyhotel.co.uk/',
      distanceToVenue: '7 miles'
    },
    {
      name: 'Travelodge Chelmsford Hotel',
      address: 'Riverside Retail Park, Victoria Rd, Chelmsford CM1 1AN, UK',
      phone: '+44 871 984 6483',
      image: '/accommodation-images/travelodge-chelmsford.jpg',
      link: 'https://www.travelodge.co.uk/hotels/649/Chelmsford-hotel',
      distanceToVenue: '7 miles'
    }
  ];

  return (
    <div className="page-container">
      <h2 className="page-title">Accommodation Options</h2>
      <p className="page-subtitle">Here are some nearby accommodation options for your stay</p>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '30px'
      }}>
        {accommodations.map((hotel, index) => (
          <div key={index} className="card" style={{
            overflow: 'hidden',
            textAlign: 'center',
            flex: '1 1 300px',
            maxWidth: '320px',
            padding: 0
          }}>
            <img
              src={hotel.image}
              alt={hotel.name}
              style={{
                width: '100%',
                height: 'clamp(150px, 25vw, 180px)',
                objectFit: 'cover'
              }}
            />
            <div style={{ padding: '15px' }}>
              <h3 style={{ 
                margin: '0 0 8px',
                fontFamily: 'var(--font-heading)',
                fontSize: 'clamp(1.1rem, 3vw, 1.3rem)',
                color: 'var(--text-primary)'
              }}>{hotel.name}</h3>
              <p style={{ 
                margin: '0 0 6px',
                fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }}>{hotel.address}</p>
              <p style={{ 
                margin: '0 0 6px',
                fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }}>{hotel.phone}</p>
              <p style={{ 
                margin: '0 0 10px', 
                fontStyle: 'italic',
                fontSize: 'clamp(0.85rem, 2.5vw, 0.95rem)',
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)'
              }}>Distance to venue: {hotel.distanceToVenue}</p>
              <div style={{ marginTop: '10px' }}>
                <a
                  href={hotel.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button-primary"
                  style={{
                    fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                    textDecoration: 'none',
                    display: 'inline-block'
                  }}
                >
                  View on site
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Accommodation;